import $ from 'jquery';

// import constants and paths
import { localStorageUUIDFieldName } from './config.js';

let tvsmilesUUID = null;


function createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
    });
}

function registerDevice(tvsAddress, uuid) {
    const settings = {
        async: true,
        crossDomain: true,
        url: `${tvsAddress}/api/v2/user/register`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
        data: `{udid: '${uuid}',deviceUserAgent: '${navigator.userAgent}',}`,
    };

    return $.ajax(settings);
}

export default function getUUID(tvsAddress) {
    /*eslint-disable */
    const dfd = $.Deferred();
    /*eslint-enable */
    if (window.localStorage) {
        tvsmilesUUID = window.localStorage.getItem(localStorageUUIDFieldName);
    }

    console.log('Looking for new UUID');

    if (!tvsmilesUUID) { // TODO: TEST IT
        // 3 attempts in case of fail (might be duplicate [incredibly rare])
        (function tryRegisteringDeviceOnServer(i) {
            tvsmilesUUID = createUUID();
            // register the new Device
            registerDevice(tvsAddress, tvsmilesUUID)
                .done(() => {
                    localStorage.setItem(localStorageUUIDFieldName, tvsmilesUUID);
                    dfd.resolve(tvsmilesUUID);
                })
                .fail(() => {
                    if (i < 3) {
                        tryRegisteringDeviceOnServer(i + 1);
                    } else {
                        dfd.reject(
                            new Error('Could not get a successful registration after 3rd try.')
                        );
                    }
                });
        }(0));
    } else {
        dfd.resolve(tvsmilesUUID);
    }

    return dfd.promise();
}



// WEBPACK FOOTER //
// ./src/campaign/challenges/sevenPassLogin/uuid.jsx